import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ESPACO } from "../data/content";
import { ArrowRight, Check } from "lucide-react";
import useSiteContent from "../hooks/useSiteContent";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export const Espaco = () => {
  const preview = ESPACO.gallery.slice(0, 3);
  const cms = useSiteContent();
  const e = cms.espaco || {};
  const features = (e.features && e.features.length ? e.features : ESPACO.features) || [];
  return (
    <section id="espaco" data-testid="espaco-section" className="bg-cream py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div {...fadeUp} className="lg:col-span-6">
          <p className="label-editorial text-clay mb-6">{e.kicker || "O Espaço"}</p>
          <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-none">
            {e.home_heading_before || "O nosso espaço, à sua"}{" "}
            <span className="italic text-clay">{e.home_heading_highlight || "espera"}</span>
            {e.home_heading_after ? ` ${e.home_heading_after}` : ""}
          </h2>
          <p className="mt-8 text-black/60 font-light leading-relaxed text-base md:text-lg max-w-xl whitespace-pre-line">
            {e.intro || ESPACO.intro}
          </p>
          <ul className="mt-8 space-y-3">
            {features.map((f) => (
              <li key={f} className="flex items-start gap-3 text-black/70 font-light">
                <span className="mt-0.5 w-5 h-5 flex items-center justify-center bg-clay/10 text-clay shrink-0">
                  <Check size={13} />
                </span>
                {f}
              </li>
            ))}
          </ul>
          <Link
            to="/espaco"
            data-testid="espaco-view-all"
            className="mt-10 inline-flex items-center gap-2 label-editorial bg-clay text-white px-8 py-4 hover:bg-clay-dark transition-colors duration-300"
          >
            Ver o espaço <ArrowRight size={15} />
          </Link>
        </motion.div>

        <motion.div {...fadeUp} className="lg:col-span-6">
          <div className="grid grid-cols-2 gap-3">
            <div className="gallery-item col-span-2 overflow-hidden aspect-[16/10]">
              <img
                src={preview[0].src}
                alt={preview[0].caption}
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
            {preview.slice(1).map((img) => (
              <div key={img.src} className="gallery-item overflow-hidden aspect-square">
                <img
                  src={img.src}
                  alt={img.caption}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
